import styled, { css } from "styled-components";

const container = styled.ul<{ type: "default" | "search" | "video" }>`
  padding: 24px 0;

  ${(props) => {
    switch (props.type) {
      case "default":
        return css``;

      case "search":
        return css``;

      case "video":
        return css`
          display: flex;
          flex-wrap: wrap;
        `;
    }
  }}
`;

export default {
  container,
};
